import {
  alphabetCountyRegex,
  alphabetRegex,
  anyCharacters,
  cityFieldRegex,
  emailRegex,
  numAlphabetOnlyRegex,
  numberOnlyRegex,
  patientNameRegex,
  personNameRegex,
  phoneFaxFormat,
  physicianNameRegex,
} from "../../constants/Regex";

const city = {
  maxLength: { value: 100, message: "100 characters are allowed" },
  pattern: { value: cityFieldRegex, message: `Please enter valid city.` },
};
const state = {
  maxLength: { value: 100, message: "100 characters are allowed." },
  pattern: { value: alphabetRegex, message: `Please enter valid state.` },
};

const cityRequired = {
  ...city,
  required: { value: true, message: "City is required." },
};
const stateRequired = {
  ...state,
  required: { value: true, message: "State is required." },
};
const streetName2 = {
  maxLength: { value: 100, message: "100 characters or digits is allowed" },
};

const streetName2Required = {
  required: { value: true, message: "Street 2 is required." },
  ...streetName2,
};
const agencyStreetName1 = {
  maxLength: { value: 100, message: "100 characters or digits is allowed" },
};
const agencyStreetName1Required = {
  ...agencyStreetName1,
    required: { value: true, message: "Street name 1 is required." },
};
const agencyZipCode = {
  pattern: {
    value: numberOnlyRegex,
    message: `Please enter valid Zip Code.`,
  },
};
const agencyZipCodeRequired = {
  ...agencyZipCode,
  required: { value: true, message: "Zip Code is required." },
};

const npi = {
  validate: (value: string) => {
    const DIGIT_MATCH = /^\d+$/;
    const RESIDUES = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    const message = "Please enter valid NPI.";

    const luhn = (num: string): boolean => {
      if (!num || !DIGIT_MATCH.test(num)) return false;
      let sum = 0;
      for (let i = num.length - 1, pos = 0; i >= 0; i--, pos++) {
        const digit = +num[i];
        sum += pos % 2 === 0 ? digit : RESIDUES[digit];
      }
      return sum % 10 === 0;
    };

    if (!value || value.length === 0) return true;
    if (value.length !== 10 || !luhn("80840" + value)) return message;
    return true;
  }
};

const npiRequired = {
  required: { value: true, message: "NPI is required" },
  validate: npi.validate,
};

export const rules = {
  firstName: {
    pattern: {
      value: personNameRegex,
      message: "Please enter valid first name.",
    },
    required: { value: true, message: `First name is required.` },
  },
  lastName: {
    pattern: {
      value: personNameRegex,
      message: "Please enter valid last name.",
    },
    required: { value: true, message: `Last name is required.` },
  },
  eligibilityFirstName: {
    pattern: {
      value: patientNameRegex,
      message: "Please enter valid last name.",
    },
    required: { value: true, message: `Last name is required.` },
  },
   patientFirstName: {
    pattern: {
      value: patientNameRegex,
      message: "Please enter valid first name.",
    },
  },
  emergencyContactName: {
    required: { value: true, message: `Contact name is required.` },
    maxLength: { value: 30, message: "30 characters are allowed." },
    pattern: {
      value: personNameRegex,
      message: "Please enter valid contact name.",
    },
  },
  contactName: {
    required: { value: true, message: `Contact name is required.` },
    maxLength: { value: 100, message: "100 characters are allowed." },
    pattern: {
      value: personNameRegex,
      message: "Please enter valid contact name.",
    },
  },
  phone: {
    required: { value: true, message: `Phone no. is required.` },
    maxLength: { value: 14, message: "Max length should be 14 digit." },
    minLength: {
      value: 14,
      message: "Min length should be 10 digit.",
    },
    pattern: {
      value: phoneFaxFormat,
      message: "Please enter valid phone number.",
    },
  },
  emergencyContactPhone: {
    required: { value: true, message: `Phone no. is required.` },
    maxLength: { value: 14, message: "Max length should be 14 digit." },
    minLength: {
      value: 14,
      message: "Min length should be 10 digit.",
    },
    pattern: {
      value: phoneFaxFormat,
      message: "Please enter valid phone number.",
    },
  },
  healthPlan: {
    required: { value: true, message: "Health plan is required." },
  },
  infoSubscriberId: {
    required: { value: true, message: "Subscriber ID is required." },
  },
  streetName1: {
    required: { value: true, message: "Street name 1 is required." },
  },
  serviceProviderStreetName1: {
    required: { value: true, message: "Street name 1 is required." },
    maxLength: { value: 100, message: "100 characters or digits is allowed" },
  },
  streetName2,
  streetName2Required,
  county: {
    maxLength: { value: 100, message: "100 characters are allowed" },
    pattern: {
      value: alphabetCountyRegex,
      message: `Please enter valid county.`,
    },
  },
  city,
  cityRequired,
  state,
  stateRequired,
  agencyStreetName1,
  agencyStreetName1Required,
  agencyZipCode,
  agencyZipCodeRequired,
  zipcode: {
    maxLength: { value: 10, message: "Max length should be 10 digit." },
    pattern: {
      value: numberOnlyRegex,
      message: `Please enter valid Postal Code.`,
    },
    required: { value: true, message: "Postal Code is required." },
  },
  gender: {
    required: { value: true, message: "Gender is required." },
  },
  language: {
    required: { value: true, message: "Language is required." },
  },
  dateOfBirth: {
    required: { value: true, message: "Date of birth is required." },
  },
  Document: {
    required: { value: true, message: "Document is required." },
  },
  physicianName: {
    required: { value: true, message: "Physician name  is required." },
    pattern: { value: physicianNameRegex, message: `Please enter valid name.` },
  },
  orderingPrescriber: {
    required: { value: true, message: "Ordering Prescriber  is required." },
    pattern: { value: physicianNameRegex, message: `Please enter valid name.` },
  },
  emailAddress: {
    pattern: {
      value: emailRegex,
      message: "Please enter valid email address.",
    },
  },
  emailAddressOptional: {
    pattern: {
      value: emailRegex,
      message: "Please enter valid email address.",
    },
  },
  physicianCounty: {
    required: { value: true, message: "County is required." },
    maxLength: { value: 100, message: "100 characters are allowed" },
    pattern: {
      value: alphabetCountyRegex,
      message: `Please enter valid county.`,
    },
  },
  physicianZipcode: {
    required: { value: true, message: "Zip code  is required." },
    maxLength: { value: 10, message: "Max length should be 10 digit." },
    pattern: {
      value: numberOnlyRegex,
      message: `Please enter valid zipcode.`,
    },
  },
  agencyCounty: {
    maxLength: { value: 100, message: "Max length should be 100 digit." },
    pattern: {
      value: alphabetCountyRegex,
      message: `Please enter valid county.`,
    },
  },
  agencyContactName: {
    required: { value: true, message: "Agency contact name is required." },
  },
  agencyBranchName: {
    required: { value: true, message: "Agency branch name is required." },
  },
  physicianNpi: npiRequired,
  mobilePhone: {
    maxLength: { value: 14, message: "Max length should be 14 digit." },
    minLength: {
      value: 14,
      message: "Min length should be 10 digit.",
    },
    pattern: {
      value: phoneFaxFormat,
      message: "Please enter valid phone number.",
    },
  },
  sendFax: {
    required: { value: true, message: `Fax is required.` },
    maxLength: { value: 14, message: "Max length should be 14 digit." },
    minLength: { value: 14, message: "Min length should be 10 digit." },
    pattern: {
      value: phoneFaxFormat,
      message: "Please enter valid fax number.",
    },
  },
  fax: {
    maxLength: { value: 14, message: "Max length should be 14 digit." },
    minLength: { value: 14, message: "Min length should be 10 digit." },
    pattern: {
      value: phoneFaxFormat,
      message: "Please enter valid fax number.",
    },
  },
  npiRequired,
  referralFacility: {
    maxLength: { value: 100, message: "100 characters are allowed." },
    required: { value: true, message: `Referral facility is required.` },
  },
  referralSourceFacilityTypeId: {
    required: {
      value: true,
      message: `Referral source facility type is required.`,
    },
  },
  referralSourceDischargeDate: {
    required: { value: true, message: "Date is required." },
  },
  discipline: {
    required: { value: true, message: `Discipline is required` },
  },
  checkEligibilitySubscriberId: {
    required: { value: true, message: "Subscriber ID is required" },
    pattern: {
      value: numAlphabetOnlyRegex,
      message: `Please enter valid value.`,
    },
    maxLength: { value: 15, message: "15 characters or digits is allowed" },
  },
  checkEligibilityHealthPlan: {
    required: { value: true, message: "Health plan id required" },
    patter: { value: anyCharacters, message: "Please select valid plan." },
  },
  bcbs: {
    required: { value: true, message: "Please select an option" },
  },
  agencyName: {
    required: { value: true, message: "Enter required field." },
  },
  providerName: {
    pattern: {
      value: personNameRegex,
      message: "Please enter valid provider name.",
    },
  },
  icd10Code: {
    required: {
      value: true,
      message: "ICD code is required",
    },
    maxLength: { value: 75, message: "75 characters are allowed" },
  },
  icd10CodeType: {
    required: {
      value: true,
      message: "ICD code type is required",
    },
  },
  icdCodes: {
    required: { value: true, message: "Please add ICD codes" },
    minLength: 1,
  },
  checkBox: {
    validate: (value: boolean) =>
      value || "You must have to agree to proceed further.",
  },
  relation: {
    required: { value: true, message: "Relation is required." },
  },
};
